<template>
  <!-- prettier-ignore -->
  <div class="literature-container">
    <div class="w1300 wapper">
      <!-- 学科研究文献标题 -->
      <div class="literature-header">
        <h2>学科研究文献</h2>
        <p>探索学科领域的最新研究成果和重要文献</p>
      </div>

      <!-- 文献类型tab -->
      <div class="literature-tabs">
        <div
          class="tab-item"
          :class="{ active: activeTab === index }"
          v-for="(tab, index) in tabList"
          :key="index"
          @click="switchTab(index)"
        >
          {{ tab.name }}
        </div>
      </div>

      <!-- 最新文献 -->
      <div v-if="activeTab === 0" class="tab-content">
        <div class="content-header">
          <h3>最新文献</h3>
        </div>
        <div class="literature-list">
          <article-list
            :parentConceptName="subjectKeywords"
            :parentConceptId="subjectId"
            :orderField="orderField"
            ref="childRef"
          >
          </article-list>
        </div>
      </div>

      <!-- <div class="hello">
        <iframe src="/static/aa.html" id="qt" scrolling="no" frameborder="0" style="position: absolute; top: 64px; left: 0px; right: 0px; bottom: 100px;"></iframe>
      </div> -->

      <!-- 高被引文献 -->
      <!-- <div v-if="activeTab === 1" class="tab-content">
        <div class="content-header">
          <h3>高被引文献</h3>
        </div>
        <div class="literature-list">

          <article-list
            :parentConceptName="subjectKeywords"
            :parentConceptId="subjectId"
            :orderField="orderField"
            ref="childRef"
          >
          </article-list>
        </div>
      </div> -->

      <!-- 奠基性文献 -->
      <div v-if="activeTab === 1" class="tab-content">
        <div class="content-header">
          <h3>奠基性文献</h3>
        </div>
        <div class="literature-list">
          <subject-list-skeleton v-if="basicLoading" variant="article" :rows="4" />

          <div v-else-if="!basicIframeSrc" class="no-data">
            <!-- <img src="../../assets/images/noData.png" alt="暂无数据" /> -->
            <el-empty description="暂无数据"></el-empty>
          </div>
          <div v-else class="list-items">
            <!-- 嵌入HTML文件 -->
            <div class="landmark-papers-iframe">
              <iframe
                :src="basicIframeSrc"
                frameborder="0"
                scrolling="auto"
                title="Computer Science Applications领域奠基文献分析"
              >
              </iframe>
            </div>
          </div>
        </div>
      </div>

      <!-- 研究主题分析 -->
      <div v-if="activeTab === 2" class="tab-content">
        <div class="content-header">
          <h3>研究主题分析</h3>
        </div>
        <div class="topic-analysis">
          <subject-list-skeleton v-if="topicLoading" variant="article" :rows="4" />
          <div v-else-if="!topicIframeSrc" class="no-data">
            <!-- <img src="../../assets/images/noData.png" alt="暂无数据"> -->
            <el-empty description="暂无数据"></el-empty>
          </div>
          <div v-else class="analysis-content">
            <div class="landmark-papers-iframe">
              <iframe
                :src="topicIframeSrc"
                frameborder="0"
                scrolling="auto"
                title="Computer Science Applications领域研究主题分析"
              >
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../../utils/eventBus";
import ArticleList from "../../views/Trend/article";
import SubjectListSkeleton from "@/components/SubjectListSkeleton.vue";
import baseurl from "../../api/baseurl";

export default {
  name: "Literature",
  components: {
    ArticleList,
    SubjectListSkeleton,
  },
  data() {
    return {
      activeTab: 0,
      tabList: [
        { name: "最新文献", key: "latest" },
        // { name: "高被引文献", key: "cited" },
        { name: "奠基性文献", key: "basic" },
        { name: "研究主题分析", key: "topic" },
      ],
      // 最新文献和高被引文献现在使用ArticleList组件，无需额外的数据字段
      // 奠基性文献相关
      basicLoading: false,
      basicIframeSrc: "",
      basicPage: 1,
      basicTotal: 0,
      basicFilter: {
        category: "",
        impact: "",
      },
      // 研究主题分析相关
      topicLoading: false,
      topicIframeSrc: "",
      topicFilter: {
        timeRange: "5",
        analysisType: "cluster",
      },
      subjectId: "",
      searchKeywords: "",
      subjectKeywords: "",
      orderField: "publishDate",
    };
  },

  mounted() {
    // 检查是否已有学科ID
    this.timer = setInterval(() => {
      // 检查是否已通过EventBus加载数据
      if (sessionStorage.getItem("subjectNodes")) {
        let subjectNode = JSON.parse(sessionStorage.getItem("subjectNodes"));
        // 使用英文名称而不是label，确保传参始终为英文
        let subjectValue = subjectNode.name;
        this.getSubjectname(subjectValue);
      }
    }, 300);
    EventBus.$on("SubjectName", name => {
      this.getSubjectname(name);
    });
  },

  beforeDestroy() {
    EventBus.$off("submitSubject");
    EventBus.$off("SubjectName");
  },

  methods: {
    // 构建完整可访问的 URL
    buildAbsoluteUrl(path) {
      if (!path) return "";
      if (/^https?:\/\//i.test(path)) return path;
      const prefix = baseurl && baseurl.baseUrl ? String(baseurl.baseUrl) : String(window.location.origin + "/");
      return prefix.replace(/\/+$/, "") + "/" + String(path).replace(/^\/+/, "");
    },
    // 获取选中的学科英文代码作为 subject
    getSubjectname(subjectName) {
      window.clearInterval(this.timer);
      if (!subjectName || subjectName === this.subjectKeywords) return;
      this.subjectKeywords = subjectName;
      this.loadData();
    },
    switchTab(index) {
      this.activeTab = index;
      this.loadData();
      // console.log("切换到标签页：", index, "测试数据：", this.testData);
      if (index === 0) {
        this.orderField = "publishDate";
        this.$nextTick(() => {
          this.$refs.childRef.topHotWords = ""; // 清空检索词
          this.$refs.childRef.childMethod("publishDate", this.subjectKeywords);
        });
      }
      // else if (index === 1) {
      //   this.orderField = "citedCount";
      //   this.$nextTick(() => {
      //     this.$refs.childRef.topHotWords = ""; // 清空检索词
      //     this.$refs.childRef.childMethod("citedCount", this.subjectKeywords);
      //   });
      //   // this.$refs.citedRef.childMethod("citedCount");
      // }
    },

    loadData() {
      if (!this.subjectKeywords) return;
      switch (this.activeTab) {
        // 最新文献和高被引文献使用ArticleList组件，无需额外加载
        case 0:
        case 1:
          this.loadBasicLiterature();

          break;
        case 2:
          this.loadTopicAnalysis();
          // this.loadBasicLiterature();
          break;
        // case 3:
        //   this.loadTopicAnalysis();
        //   break;
      }
    },

    // 最新文献和高被引文献现在使用ArticleList组件，无需额外加载逻辑

    // 加载奠基性文献
    loadBasicLiterature() {
      this.basicLoading = true;
      const subject = this.subjectKeywords;
      if (!subject) {
        this.basicIframeSrc = "";
        this.basicLoading = false;
        return;
      }
      this.$http({
        url: "api/v1/subject/gateway/getHtmlBySubject",
        method: "POST",
        data: {
          subject: subject,
          type: "landmarck",
        },
      })
        .then(res => {
          this.basicIframeSrc = this.buildAbsoluteUrl(res && res.data ? res.data : "");
        })
        .catch(error => {
          console.warn("奠基性文献加载失败:", error);
          this.basicIframeSrc = "";
          // 不弹窗，静默处理失败情况
        })
        .finally(() => {
          this.basicLoading = false;
        });
    },

    // 加载研究主题分析
    loadTopicAnalysis() {
      this.topicLoading = true;
      const subject = this.subjectKeywords;
      if (!subject) {
        this.topicIframeSrc = "";
        this.topicLoading = false;
        return;
      }
      this.$http({
        url: "api/v1/subject/gateway/getHtmlBySubject",
        method: "POST",
        data: {
          subject: subject,
          type: "reseachnew",
        },
      })
        .then(res => {
          this.topicIframeSrc = this.buildAbsoluteUrl(res && res.data ? res.data : "");
        })
        .catch(error => {
          console.warn("研究主题分析加载失败:", error);
          this.topicIframeSrc = "";
          // 不弹窗，静默处理失败情况
        })
        .finally(() => {
          this.topicLoading = false;
        });
    },

    // 分页处理 - 最新文献和高被引文献使用ArticleList组件，分页由组件内部处理

    handleBasicPageChange(page) {
      this.basicPage = page;
      this.loadBasicLiterature();
    },

    // 查看详情
    viewDetail(item) {
      this.$message.info(`查看文献详情：${item.title}`);
      // 这里可以跳转到文献详情页面
    },

    // 下载
    download(item) {
      this.$message.success(`开始下载：${item.title}`);
    },

    // 收藏
    collect(item) {
      item.collected = !item.collected;
      this.$message.success(item.collected ? "收藏成功" : "取消收藏");
    },
  },
};
</script>

<style scoped lang="scss">
.literature-container {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 20px 0;
  overflow-x: hidden;
}

.w1300 {
  width: calc(100% - 40px);
  max-width: 1300px;
  min-width: 0;
  margin: 0 auto;
  box-sizing: border-box;
}

.literature-header {
  text-align: center;
  margin-bottom: 30px;

  h2 {
    font-size: 26px;
    color: #2c5f97;
    margin-bottom: 10px;
  }

  p {
    color: #666;
    font-size: 16px;
  }
}
// ::v-deep .container_menu {
//   max-width: 0px !important;
//   margin-right: 0px !important;
//   width: 0px !important;
//   min-height: 750px;
//   position: relative;
// }
.literature-tabs {
  display: flex;
  background: white;
  border-radius: 8px;
  padding: 5px;
  margin-bottom: 20px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .tab-item {
    flex: 1;
    text-align: center;
    padding: 15px 20px;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.3s ease;
    font-weight: 500;
    font-size: 14px;

    &:hover {
      background: #f0f7ff;
      color: #2c5f97;
    }

    &.active {
      background: #2c5f97;
      color: white;
    }
  }
}

.tab-content {
  background: white;
  border-radius: 8px;
  padding: 20px;
  min-width: 0;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;

  h3 {
    color: #2c5f97;
    margin: 0;
  }

  .filter-controls {
    display: flex;
    gap: 10px;
  }
}

.literature-list {
  .loading,
  .no-data {
    text-align: center;
    padding: 40px;
    color: #999;

    img {
      width: 80px;
      margin-bottom: 10px;
    }

    .el-icon-loading {
      font-size: 24px;
      margin-bottom: 10px;
      animation: rotate 1s linear infinite;
    }
  }

  .list-items {
    .list-item {
      border: 1px solid #eee;
      border-radius: 8px;
      padding: 20px;
      margin-bottom: 15px;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;

      &:hover {
        border-color: #2c5f97;
        box-shadow: 0 4px 12px rgba(44, 95, 151, 0.1);
      }

      &.high-cited {
        border-left: 4px solid #ff6b6b;
      }

      &.basic-literature {
        border-left: 4px solid #4ecdc4;
      }

      .cited-badge,
      .basic-badge {
        position: absolute;
        top: 15px;
        right: 15px;
        background: #ff6b6b;
        color: white;
        padding: 4px 8px;
        border-radius: 12px;
        font-size: 12px;

        &.basic-badge {
          background: #4ecdc4;
        }
      }

      .item-main {
        .title {
          font-size: 16px;
          font-weight: 400;
          color: #2c5f97;
          margin-bottom: 10px;
          line-height: 1.4;
        }

        .authors {
          color: #666;
          margin-bottom: 8px;
          font-size: 14px;
        }

        .abstract {
          color: #555;
          line-height: 1.6;
          margin-bottom: 15px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .meta {
          display: flex;
          gap: 15px;
          font-size: 14px;
          color: #888;

          .citations {
            &.highlight {
              color: #ff6b6b;
              font-weight: 500;
            }
          }

          .impact {
            color: #4ecdc4;
            font-weight: 500;
          }
        }
      }

      .item-actions {
        margin-top: 15px;
        text-align: right;
        border-top: 1px solid #eee;
        padding-top: 15px;
        font-size: 14px;
      }
    }
  }
}
.pagination {
  text-align: center;
  margin-top: 20px;
}

.topic-analysis {
  .loading,
  .no-data {
    text-align: center;
    padding: 40px;
    color: #999;

    img {
      width: 80px;
      margin-bottom: 10px;
    }

    .el-icon-loading {
      font-size: 24px;
      margin-bottom: 10px;
      animation: rotate 1s linear infinite;
    }
  }

  .analysis-content {
    .cluster-chart,
    .keyword-analysis,
    .network-analysis {
      h4 {
        color: #2c5f97;
        margin-bottom: 20px;
      }

      .chart-container,
      .keyword-cloud,
      .trend-chart,
      .network-chart {
        .placeholder-chart {
          text-align: center;
          padding: 60px 20px;
          background: #f8f9fa;
          border-radius: 8px;
          border: 2px dashed #ddd;

          i {
            font-size: 48px;
            color: #ccc;
            margin-bottom: 15px;
          }

          p {
            font-size: 18px;
            color: #666;
            margin-bottom: 10px;
          }

          span {
            color: #999;
            font-size: 14px;
          }
        }
      }

      .keyword-trends {
        margin-top: 30px;

        h5 {
          color: #2c5f97;
          margin-bottom: 15px;
        }
      }
    }
  }
}

// 加载动画
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

// 奠基文献iframe样式
.landmark-papers-iframe {
  width: 100%;
  max-width: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: white;
  margin: 20px 0;

  iframe {
    border: none;
    border-radius: 8px;
    background: white;
    width: 100%;
    min-height: 900px;
    max-height: 1400px;
    display: block;

    &:focus {
      outline: none;
    }
  }

  // 响应式调整
  @media (max-width: 1300px) {
    iframe {
      min-height: 800px;
      max-height: 1300px;
    }
  }

  @media (max-width: 768px) {
    iframe {
      min-height: 700px;
      max-height: 1000px;
    }
  }

  @media (max-width: 480px) {
    iframe {
      min-height: 600px;
      max-height: 900px;
    }
  }
}

// 研究主题分析iframe样式
.research-report-iframe {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: white;
  margin: 20px 0;

  iframe {
    border: none;
    border-radius: 8px;
    background: white;
    width: 100%;
    min-height: 1000px;
    max-height: 1600px;
    display: block;

    &:focus {
      outline: none;
    }
  }

  // 响应式调整
  @media (max-width: 1300px) {
    iframe {
      min-height: 900px;
      max-height: 1400px;
    }
  }

  @media (max-width: 768px) {
    iframe {
      min-height: 800px;
      max-height: 1300px;
    }
  }

  @media (max-width: 480px) {
    iframe {
      min-height: 700px;
      max-height: 1000px;
    }
  }
}

// 响应式设计
@media (max-width: 1300px) {
  .w1300 {
    width: calc(100% - 40px);
  }
}

@media (max-width: 768px) {
  .literature-container {
    padding: 12px 0;
  }

  .w1300 {
    width: calc(100% - 24px);
  }

  .literature-header {
    margin-bottom: 20px;

    h2 {
      font-size: 22px;
    }

    p {
      font-size: 14px;
      line-height: 1.6;
    }
  }

  .literature-tabs {
    overflow-x: auto;
    padding: 4px;

    .tab-item {
      flex: 0 0 auto;
      min-width: 120px;
      padding: 11px 14px;
      white-space: nowrap;
    }
  }

  .tab-content {
    padding: 14px 12px;
  }

  .content-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;

    .filter-controls {
      width: 100%;
      justify-content: space-between;
    }
  }

  .landmark-papers-iframe {
    margin: 10px 0 0;
    border-radius: 4px;

    iframe {
      border-radius: 4px;
    }
  }
}
</style>
